export default "__VITE_ASSET__CGPHd1jK__"